import { PieChartData, shortenNumber, theme } from '../..';
import { LegendProps } from '@nivo/legends';
import { ResponsivePie } from '@nivo/pie';

import { NoData } from '../no-data';

const getCenteredMetricComponent = (value: string | number | null) => {
  return ({
    centerX,
    centerY,
  }: {
    centerX: number;
    centerY: number;
    // metric: number;
  }) => {
    if (value === null) {
      return null;
    }

    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        fill="white"
        style={{ color: '#FFFFFF', fontSize: '32px' }}
      >
        {value}
      </text>
    );
  };
};

export const PieChart = ({
  data,
  sortByValue,
  enableArcLinkLabels,
  enableArcLabels,
  centeredMetric,
  legends,
}: {
  data: PieChartData;
  sortByValue: boolean;
  enableArcLinkLabels: boolean;
  enableArcLabels: boolean;
  centeredMetric: number | null | string;
  legends?: LegendProps[];
}) => {
  if (!data?.length) {
    return <NoData />;
  }
  return (
    <ResponsivePie
      data={data}
      id="category"
      theme={theme}
      margin={{ top: 32, right: 32, bottom: 32, left: 32 }}
      startAngle={1}
      sortByValue={sortByValue}
      innerRadius={0.7}
      // innerText={100 - (percentage * 100).toFixed(1) + '%'}
      padAngle={1}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.2]],
      }}
      enableArcLinkLabels={enableArcLinkLabels}
      enableArcLabels={enableArcLabels}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor={{ from: 'color' }}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={10}
      arcLinkLabel={(d) => `${d.id} `}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [['darker', 3]],
      }}
      colors={{ scheme: 'dark2' }}
      legends={legends}
      layers={[
        'arcs',
        'arcLabels',
        'arcLinkLabels',
        'legends',
        getCenteredMetricComponent(centeredMetric),
      ]}
      tooltip={({ datum }) => {
        return (
          <div
            style={{
              padding: 8,
              background: theme.tooltip.container.background,
            }}
          >
            <span>{datum.id}</span>:{' '}
            <strong>{shortenNumber(datum.value, 2)}</strong>
          </div>
        );
      }}
    />
  );
};